module.exports = __webpack_public_path__ + "static/assets/06b403062f900abdf69065da378751d6.png";